export default __webpack_public_path__ + "static/bus-tracking-system-enhancing-student-safety-e18a660ff1be218a55512c838e54d48e.jpg";